export const PRACTICE_STATUSES = [
  { label: 'Pending', value: 'pending' },
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' }
];

export const REQUEST_STATUSES = [
  { label: 'Requested', value: 'requested' },
  { label: 'In progress', value: 'in progress' },
  { label: 'Completed', value: 'completed' }
];

// How far a migration has actually got, in order. `task.status` above is the
// coarse three-value rollup shared with every other task in the app; this is the
// progression the imports screens render. Mirrors the backend's
// utility/import_requests/stages.js — keep the two in step.
export const IMPORT_STAGES = [
  { value: 'requested', label: 'Requested' },
  { value: 'data_uploaded', label: 'Data uploaded' },
  { value: 'processing_data', label: 'Processing data' },
  { value: 'pending_review', label: 'Pending review' },
  { value: 'complete', label: 'Complete' }
];

export const STAGE_LABELS = IMPORT_STAGES.reduce(
  (accumulator, stage) => ({ ...accumulator, [stage.value]: stage.label }),
  {}
);

export const stageIndex = (stage) => IMPORT_STAGES.findIndex(({ value }) => value === stage);

// An import_info / patient_imports run in one of these states is still going on
// Astro — the Import step shows live progress while any run is here, and Start
// import stays disabled. `finalizing` is emitted by the CSV import webhook
// (utility/astro/webhookHandlers/csvImport.js), so it belongs here too.
//
// This is the single source for "still running": every screen and hook derives
// from it rather than keeping its own list.
// A request's runs come from two tables with independent id sequences:
// `import_info` (EHR exports, kind 'ehr') and `patient_imports` (mapped CSVs,
// kind 'csv'). A bare "#642" could be either, so every place that names a run
// says which ledger the number belongs to — and only an EHR run can ever be the
// request's final_import_info_id, which is a foreign key into import_info.
export const RUN_KIND_LABELS = { ehr: 'EHR', csv: 'CSV' };

export const runLabel = (run) => `${RUN_KIND_LABELS[run?.kind] || 'Import'} #${run?.id ?? '—'}`;

export const runKey = (run) => `${run?.kind || 'run'}-${run?.id}`;

export const isFinalRunCandidate = (run) => run?.kind === 'ehr';

export const IN_FLIGHT_IMPORT_STATUSES = ['queued', 'unzipping', 'processing', 'finalizing'];

export const isInFlightStatus = (status) =>
  IN_FLIGHT_IMPORT_STATUSES.includes(String(status || '').toLowerCase());

// Uploaded but never launched: what Start import picks up.
export const AWAITING_START_STATUSES = ['initiated', 'uploading', 'uploaded'];

// Nothing can abort an in-flight transfer, and leaving the page kills it
// outright — so every exit while one is running has to be confirmed.
export const UPLOAD_IN_PROGRESS_TITLE = 'Upload in progress';
export const UPLOAD_IN_PROGRESS_MESSAGE =
  "Files are still uploading. If you leave now, the unfinished ones won't be imported and you'll have to upload them again.";
